import { useModuleBEM, useAirPriceWatchStyles } from "@b2bportal/core-themes";
import { CoreAirPriceWatchComponent } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { WatchList, type WatchListProps } from "@tenant/air-price-watch";
import { TripsAppPage } from "@tenant/ui";
import {
  useEmitCoreAirPriceWatchEventOnce,
  AirPriceWatchRawEventName,
} from "../../tracking";
import defaultStyles from "./WatchListPage.module.scss";

export const WatchListPage = (props: WatchListProps) => {
  const styles = useAirPriceWatchStyles(
    CoreAirPriceWatchComponent.WatchListPage,
    defaultStyles
  );
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(
    styles,
    CoreAirPriceWatchComponent.WatchListPage
  );

  useEmitCoreAirPriceWatchEventOnce(
    {
      name: AirPriceWatchRawEventName.AirPriceWatchesLoaded,
      properties: {
        active_watches: props.watches?.watches.length ?? 0,
      },
    },
    !props.isLoading
  );

  return (
    <TripsAppPage
      className={block}
      title={props.title ?? "My Watches"}
      onBackClick={props.onBackClick}
    >
      {!props.isLoading && (
        <>
          <div className={cn("watch-list-title")}>{t("watchedTripsTitle")}</div>
          <div className={cn("watch-list-subtitle")}>
            {t("watchedTripsSubtitle")}
          </div>
        </>
      )}
      <WatchList {...props} />
    </TripsAppPage>
  );
};
